module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/assets/clear.svg
// module id = dGLe
// module chunks = 1